import { useMemo } from 'react';

import { useIsCrownSportVisible } from '../../../hooks/useIsCrownSportVisible';
import { useStores } from '../../../stores/useStores';
import type { MonetizationWidgetDataType, WidgetEntry } from '../types';

export function useMonetizationWidgets() {
  const { sportEventsStore } = useStores();

  const isCrownSportVisible = useIsCrownSportVisible();
  const { sportEvent } = sportEventsStore;

  const monetizationWidgets: MonetizationWidgetDataType[] = useMemo(() => {
    if (isCrownSportVisible && sportEvent) {
      return [
        {
          key: sportEvent.id,
          type: 'monetization',
          event: sportEvent,
          dataTestId: `monetization-event-${sportEvent.gameNameType}-${sportEvent.id}-widget`,
        },
      ];
    }
    return [];
  }, [isCrownSportVisible, sportEvent]);

  return useMemo(
    () =>
      monetizationWidgets.map((data): WidgetEntry<'monetization'> => ({ data, type: 'monetization', id: data.key })),
    [monetizationWidgets],
  );
}
